<script>
export default {
    data() {
        return {
            version: import.meta.env.VITE_APP_VERSION
        }
    }
}
</script>

<template>
    <p>v{{ version }}</p>
</template>